








import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import AppSimpleSelector from '@/components/AppSimpleSelector.vue'
import AppSelectorMulti from '@/components/AppSelectorMulti.vue'

import { FilterSelect } from '../interfaces/filter-model'

@Component({
  components: {
    AppSimpleSelector,
    AppSelectorMulti
  }
})

export default class DialogMultiSelectorForm extends Vue {
  @Prop({ type: Object as () => FilterSelect }) readonly filterData!: any

  filter : FilterSelect = {
    key: '',
    label: '',
    type: -1,
    value: [],
    options: []
  }

  options = ['include', 'exclude']

  @Watch('filterData', { deep: true, immediate: true })
  handlePropChange (val: FilterSelect) {
    if (val) {
      this.filter = val
    }
  }

  @Emit('change')
  onChange () {
    return {
      key: this.filter.key,
      type: this.filter.type,
      value: this.filter.value
    }
  }
}

